export { default } from './ErrorContent';
